// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3PtPT","subheader":"ReorderModal_subheader__2G0mc","listWrap":"ReorderModal_listWrap__16sfM"};